import { NavigationItem } from '@app/shared/interfaces';

export const defaultNavigationItems: NavigationItem[] = [
  {
    id: 'community',
    label: 'Community',
    icon: 'outlaw-recommend-empty',
    route: '/',
    dataTest: 'btn-navigation-community',
  },
  {
    id: 'profile',
    label: 'Profile',
    icon: 'icon-menu-profile',
    route: '/profile',
    dataTest: 'btn-navigation-profile',
  },
  {
    id: 'chat-ai',
    label: 'Chat',
    icon: 'icon-menu-chat',
    route: null,
    dataTest: 'btn-navigation-ai-bot',
    disabledHint: 'Chat section is under development',
  },
];
